import { EraClaimArchiveFailure, EraClaimOutcome, TestCode } from 'store/types'

export const ERA_TEST_TYPE_OPTIONS: { key: TestCode; value: string }[] = ['POX', 'HST', 'PSG', 'COX'].map(
  (testType) => ({ key: testType as TestCode, value: testType }),
)

// What became of a claim on the Posted / Parked tab [TES-3214].
export const ERA_CLAIM_OUTCOME_OPTIONS: { key: EraClaimOutcome; value: string }[] = [
  { key: 'AUTO_POSTED', value: 'Auto-posted' },
  { key: 'BILLER_POSTED', value: 'Posted by biller' },
  { key: 'ARCHIVED', value: 'Archived' },
  { key: 'PARKED', value: 'Parked' },
]

export const ERA_CLAIM_ARCHIVE_FAILURE_LABELS: Record<EraClaimArchiveFailure, string> = {
  NOT_FOUND: 'Claim not found',
  PAYMENT_APPLIED: 'Payment already applied',
  ALREADY_ARCHIVED: 'Already archived',
  PARKED: 'Parked under Needs Work',
  CHANGED: 'Changed by someone else while archiving',
  ERROR: 'Unexpected error',
}
